import React, { useState } from 'react';
import moment from 'moment';
import DateTimePicker from './DateTimePicker';

// Generic datetime field to be used together with rails forms
const DateTimeField = props => {
  const [value, setValue] = useState(props.value);

  const handleChange = newValue => {
    if (newValue === null && props.allowOpenEnded) {
      setValue(null);
      return;
    }

    // Explicitly convert to moment
    newValue = moment(newValue);
    // If the date is not valid, dont update
    if (!newValue.isValid()) return;

    setValue(newValue.format());
  };

  // Note that 'null' is encoded as an empty string, as per Rails controller
  // convention

  return (
    <>
      <DateTimePicker
        value={value}
        onChange={handleChange}
        name={props.name}
        compact={props.compact}
        allowOpenEnded={props.allowOpenEnded || false}
        showClearButton={props.showClearButton || false}
      />
      <input type="hidden" name={props.inputName} value={value || ''} readOnly />
    </>
  );
};

export default DateTimeField;
